// Closing a promo banner. See docs/promo-banners.md section 7.
//
// The whole behaviour is: remember the dismissal in a cookie, then take the bar off the page.
// No request and no reload - the cookie is read server-side on the NEXT page, where the
// component filters the banner out before rendering it, so a closed banner never flashes up
// and disappears.
//
// DELEGATED from the document, which is what the house rule asks for (contentLifecycle.js):
// a listener registered once here needs no re-registration when content is swapped in, and a
// banner that arrives with a change of spa is closable with no further thought. There is
// deliberately no onContentReady sweep in this file - nothing here attaches per element.
//
// Progressive enhancement: without this script the close button is inert and the banner simply
// stays. That is a reasonable page, which is why the button is plain markup rendered by the
// server rather than something this file creates.

import { rememberDismissal } from './shared/promoBannerDismissal.js';
import { withHeightTransition } from './shared/promoBannerHeight.js';

const BANNER_SELECTOR = '.promo_banner';

const CLOSE_SELECTOR = '.promo_banner_close';

// The wrapper the banners live in. Always present, even with no banners inside it, because the
// content swap needs a region to match - see App\View\Components\PromoBanners::shouldRender().
const WRAPPER_SELECTOR = '#promo_banners';

document.addEventListener('click', (event) => {
    const button = event.target.closest(CLOSE_SELECTOR);

    if (! button) {
        return;
    }

    const banner = button.closest(BANNER_SELECTOR);

    if (! banner) {
        return;
    }

    // Number() on a missing attribute gives NaN, which rememberDismissal refuses - so a banner
    // rendered without its data attributes is removed from the page but not remembered, rather
    // than writing a malformed triple the server would then discard anyway.
    const id = Number(banner.dataset.promoBannerId);
    const version = Number(banner.dataset.promoBannerVersion);

    rememberDismissal(id, version);

    // Removing the bar is itself a layout shift, and the same one the swap animation exists to
    // soften - the page jumps up by the bar's whole height. Same module, same easing, so a
    // dismissal and a change of spa move the page the same way.
    withHeightTransition(document.querySelector(WRAPPER_SELECTOR), () => {
        banner.remove();
    });
});
